import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { PreInvoiceNumberArea } from "./Styles";

export default function PreInvoice({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Pre-Factura"
            value={!value ? document.documents.preInvoice.number : value}
          />
        </div>
      ) : (
        <PreInvoiceNumberArea>
          <Informative
            readonly={true}
            label="Pre-Factura"
            value={!value ? document.documents.preInvoice.number : value}
          />
        </PreInvoiceNumberArea>
      )}
    </>
  );
}
